// Constants
export const tabla_campos = () => {
  return {
    tabla_campos: {      
      id: {
        namepath: ['configuracion'],
        description: 'id autoincrement',
        label: 'Id',
        readonly: true,
        type: 'number',
        datatype: 
        {
          predeterminate: null
        }
      },
      tabla: {
        namepath: ['configuracion'],
        type: 'text',
        label: 'Nombre del Servicio',
        placeholder: '',
        description: 'Nombre del check', 
        validate: 'required',
        datatype: { 
          type: 'input', 
          disabled: false,
          predeterminate: '',
        }   
      }, 
      campo: {
        namepath: ['configuracion'],
        type: 'text',
        label: 'Nombre del Servicio',
        placeholder: '',
        description: 'Nombre del check', 
        validate: 'required',
        datatype: { 
          type: 'input', 
          disabled: false,
          predeterminate: '',
        }   
      }, 
      disabled: {
        namepath: ['configuracion'],
        description: 'si es deshabilitado',
        label: 'Disabled',
        readonly: true,
        type: 'boolean',
        datatype: 
        {
          type: 'check', 
          disabled: false,
          predeterminate: 0,
        }
      },
      autorizar: {
        namepath: ['configuracion'],
        description: 'si es deshabilitado',
        label: 'Autorizar',
        readonly: true,
        type: 'boolean',
        datatype: 
        {
          type: 'check', 
          disabled: false,
          predeterminate: 0,
        }
      },
      predeterminado: {
        namepath: ['configuracion'],
        type: 'text',
        label: 'Predeterminado',
        placeholder: '',
        description: 'Nombre del check', 
        validate: 'required',
        datatype: { 
          type: 'input', 
          disabled: false,
          predeterminate: '',
        }   
      }, 
    }
  }
}
